/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { ContactTemplateType } from '../../../contact-dialog-new/contact-dialog.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { businessConstants } from '../../../../constants/business.constants';

@Component({
    selector: 'tam-contact-alias',
    templateUrl: './contact-alias.component.html',
    styleUrls: ['./contact-alias.component.scss'],
    standalone: false
})
export class ContactAliasComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    @Input() valueChangeSubject: Subject<ContactTemplateControlValue>;
    @ViewChild('aliasInput', { static: false }) aliasInput;
    config: any;
    aliasArray: string[] = [];
    hintContent = '';
    _aliasArray: String[] = [];
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService,
    ) { }

    ngOnInit() {
        // console.log("childConfig", this.childConfig)
        this.config = this.childConfig.config;
        this._destroySubscriptions.push(
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId && this.aliasArray.length === 0 && this.config.isRequired) {
                    this.hintContent = businessConstants.tip;
                }
            }));
        if (this.config.action === ContactTemplateType.EditContact || this.config.isSignature) {
            this._initEditValue();
        }
        this.changeValueSet(false);
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    /**
     * alias changes
     *
     * @param {*} value
     * @memberof ContactAliasComponent
     */
    textChange(value) {
        this.hintContent = '';
        this._contactTemplateService.changeValueStatus = true;
        this._formatAliases();
        this.changeValueSet(true);
    }

    /**
     *init edit value
     *
     * @private
     * @memberof ContactInputComponent
     */
    private _initEditValue() {
        this.aliasArray = this._aliasArray = this.config.editValue;
        this.changeValueSet(false);
    }

    // the format of aliasArray may be changed after retrieving from server side for edit.
    private _formatAliases() {
        this._aliasArray = [];
        if (this.aliasArray) {
            for (let i = 0; i < this.aliasArray.length; i++) {
                if (this.aliasArray[i]) {
                    if (this.aliasArray[i]['value']) {
                        this._aliasArray.push(this.aliasArray[i]['value']);
                    } else {
                        this._aliasArray.push(this.aliasArray[i]);
                    }
                }
            }
        }
        return this._aliasArray;
    }

    /**
     * set value to store
     *
     * @param {boolean} isFromUser
     * @memberof ContactInputComponent
     */
    changeValueSet(isFromUser: boolean) {
        const value = new ContactTemplateControlValue(this._aliasArray, this._aliasArray, this.config);

        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
